import { Languages } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { useUIStore } from '@/stores/ui.store'

export const LanguageToggle = () => {
  const { t, i18n } = useTranslation('common')
  const locale = useUIStore((state) => state.locale)
  const toggleLocale = useUIStore((state) => state.toggleLocale)
  const switchLabel =
    locale === 'zh-CN' ? t('language.switch_to_english') : t('language.switch_to_chinese')
  const shortLabel = locale === 'zh-CN' ? t('language.english_short') : t('language.chinese_short')

  const handleToggle = () => {
    const nextLocale = toggleLocale()
    void i18n.changeLanguage(nextLocale)
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-9 px-2.5 text-primary hover:bg-primary-soft"
      aria-label={switchLabel}
      title={switchLabel}
      onClick={handleToggle}
    >
      <Languages className="h-4 w-4" aria-hidden="true" strokeWidth={1.5} />
      <span className="text-xs font-semibold tabular-nums">{shortLabel}</span>
    </Button>
  )
}
